import { types } from "../types/types";
import { fetchConToken } from '../helpers/fetch';
import { closeLoading, openModal, openModalBottom } from './ui';

export const startNewCita = (values, swal = true) => {
    return async (dispatch, getState) => {
        try {
            values.sendEmail = true;
            
            const resp = await fetchConToken('citas/cliente/crear-cita', values, 'POST');
            const body = await resp.json();
            if (body.ok) {
                if (swal) {
                    const datos = {
                        text: ['Su reserva se ha realizado con éxito'],
                        timeOut: 3
                    }
                    dispatch(openModalBottom(datos));
                }
                dispatch(addNewCita(body.cita._id, body.cita));
                if (body.cita2) {
                    dispatch(addNewCita(body.cita2._id, body.cita2));
                }
                
                const state = getState();
                const profesionalLogueado = state.auth.profesional;
                
                setTimeout(() => {
                    dispatch(startLoadingCitasMesForced(values.empresa, values.fecha, profesionalLogueado));
                }, 1000);
                return body;
            } else {
                console.log('Error!!!');
                const datos = {
                    title: 'Error',
                    text: [body.msg],
                    buttonText: 'Cerrar'
                }
                dispatch(openModal(datos));
            }
        } catch (error) {
            console.log('Error!!!');
            console.log(error);
            const datos = {
                title: 'Error',
                text: ['Ha habido un error'],
                buttonText: 'Cerrar'
            }
            dispatch(openModal(datos));
        }
    }
};

export const activeCita = (_id, cita) => ({
    type: types.citasActive,
    payload: {
        _id,
        ...cita
    }
});

export const unactiveCita = () => ({
    type: types.citasUnactive
});

export const addNewCita = (_id, cita) => ({
    type: types.citasAddNew,
    payload: {
        _id,
        ...cita
    }
});

export const addNewDobleCita = (id, cita, id2, cita2) => ({
    type: types.citasAddNewDouble,
    payload: {
        id,
        ...cita,
        id2,
        ...cita2
    }
});

export const startLoadingCitasMes = (empresa, fecha, profesionalId) => {
    return async (dispatch, getState) => {
        const state = getState();
        const monthKey = fecha.substring(0, 7);
        
        if (state.citas.citasByMonth && state.citas.citasByMonth[monthKey]) {
            console.log(`Citas para ${monthKey} ya están en cache, saltando llamada a API`);
            return;
        }

        try {
            console.log(`Cargando citas para ${monthKey} desde API`);
            const bodyData = profesionalId
                ? { empresa, fecha, profesionalId }
                : { empresa, fecha, allCitas: true };

            const resp = await fetchConToken('citas/mes', bodyData, 'POST');
            const body = await resp.json();
            dispatch(setCitas({ citas: body.citas, fecha }));
        } catch (error) {
            console.log('Error cargando citas del mes:', error);
        }
    }
};

export const startLoadingCitasMesForced = (empresa, fecha, profesionalId) => {
    return async (dispatch) => {
        try {
            const bodyData = profesionalId
                ? { empresa, fecha, profesionalId }
                : { empresa, fecha, allCitas: true };

            const resp = await fetchConToken('citas/mes', bodyData, 'POST');
            const body = await resp.json();

            dispatch(setCitas({ citas: body.citas, fecha }));
        } catch (error) {
            // Error cargando citas del mes (forced)
        }
    }
};

/**
 * @param {string} idCita
 * @param {string} empresa
 * @param {object} [mergeWith] - Objeto a fusionar con body.cita antes de dispatch (ej. { servicioActual })
 * @returns {Promise<void>}
 */
export const getCita = (idCita, empresa, mergeWith = null) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(`citas/cita/${idCita}`, { empresa }, 'POST');
            const body = await resp.json();
            if (body.cita && body.cita._id) {
                const citaToActive = mergeWith ? { ...body.cita, ...mergeWith } : body.cita;
                dispatch(activeCita(citaToActive._id, citaToActive));
            }
        } catch (error) {
            console.log('Hay error en getCita');
            console.log(error);
        }
    }
};

export const getCitas = (idCliente, empresa) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(`citas/historialcitasusuario`, { id: idCliente, empresa }, 'POST');
            const body = await resp.json();
            dispatch(setCitasHistoria(body.citas || []));
            //dispatch(startLoadingHistoriaClienteCitas(body));
        } catch (error) {
            console.log('Hay error en getCitas');
            console.log(error);
        }
    }
};

export const setCitas = (citas) => ({
    type: types.citasLoad,
    payload: citas
});

export const setCitasHistoria = (citas) => ({
    type: types.citasLoadHistory,
    payload: citas
});

export const startSaveCita = (cita) => {
    console.log( 'startSaveCita', cita );
    return async (dispatch, getState) => {
        try {
            console.log('cita', cita);
            
            const resp = await fetchConToken(`citas/${cita._id}`, cita, 'PUT');
            const body = await resp.json();

            if (body.ok) {
                const state = getState();
                const citaNormalizada = normalizarCitaParaStore(body.cita, state);
                dispatch(refreshCita(cita._id, citaNormalizada));

                const datos = {
                    text: ['Su reserva ha sido modificada'],
                    timeOut: 3
                }

                dispatch(openModalBottom(datos));
                dispatch(closeLoading());
            } else {
                console.log('Error', body);
                const datos = {
                    title: 'Error',
                    text: [body.msg],
                    buttonText: 'Cerrar'
                }
                dispatch(openModal(datos));
                dispatch(closeLoading());
            }
        } catch (error) {
            console.log(error);
            dispatch(closeLoading());
        }
    }
};

export const startSaveComentariosCita = (idCita, comentarios, swal = true) => {
    return async (dispatch, getState) => {
        try {
            const { empresa } = getState().auth;
            
            if (!empresa) {
                const datos = {
                    title: 'Error',
                    text: ['No se ha podido identificar la empresa. Por favor, recarga la página e intenta de nuevo.'],
                    buttonText: 'Cerrar'
                }
                dispatch(openModal(datos));
                return;
            }
            
            const resp = await fetchConToken(`citas/comentarios/${idCita}`, { comentarios, empresa }, 'PUT');
            const body = await resp.json();
            if (body.ok) {
                dispatch(updateComentariosCita(idCita, comentarios));
                const datos = {
                    text: ['Comentarios guardados'],
                    timeOut: 3
                }
                dispatch(openModalBottom(datos));
            } else {
                console.log(body);
                const datos = {
                    title: 'Error',
                    text: [body.msg],
                    buttonText: 'Cerrar'
                }
                dispatch(openModal(datos));
            }
        } catch (error) {
            console.log(error);
        }
    }
};

export const updateComentariosCita = (id, comentarios) => ({
    type: types.citasComentariosUpdated,
    payload: {
        _id: id,
        comentarios
    }
});

export const refreshCita = (id, cita) => ({
    type: types.citasUpdated,
    payload: {
        _id: id,
        ...cita
    }
});

/**
 * Anticipa, sin modificar nada, si cancelar la cita (o anular el servicio `servicioId`) cae en
 * periodo de penalización y cuánto se descontaría del monedero. Importes en euros.
 * Devuelve el body de la respuesta, o `{ ok: false, msg }` si la petición falla.
 */
export const startConsultarPenalizacionCita = (id, { servicioId, estadoCita } = {}) => {
    return async () => {
        try {
            const parametros = new URLSearchParams();
            if (servicioId != null && servicioId !== '') parametros.append('servicioId', servicioId);
            if (estadoCita) parametros.append('estadoCita', estadoCita);
            const query = parametros.toString();
            const endpoint = `citas/${id}/penalizacion${query ? `?${query}` : ''}`;

            const resp = await fetchConToken(endpoint);
            return await resp.json();
        } catch (error) {
            console.log(error);
            return { ok: false, msg: '' };
        }
    };
};

/**
 * Elimina una cita (DELETE). Si servicioId viene informado, solo se anula ese tramo/servicio.
 * `penalizar` solo viaja en el body si es booleano; sin él, fuera de plazo el backend penaliza.
 */
export const citaStartDelete = (id, empresa, estadoCita, servicioId, penalizar) => {
    return async (dispatch, getState) => {
        try {
            const bodyData = { empresa, estadoCita: estadoCita ?? '' };
            if (servicioId != null && servicioId !== '') {
                bodyData.servicioId = servicioId;
            }
            if (typeof penalizar === 'boolean') {
                bodyData.penalizar = penalizar;
            }
            const resp = await fetchConToken(`citas/${id}`, bodyData, 'DELETE');
            const body = await resp.json();

            if (body.ok) {

                if (body.cita && body.cita.deleted) {
                    const datos = {
                        text: ['La reserva ha sido eliminada'],
                        timeOut: 3
                    }
                    dispatch(openModalBottom(datos));
                    dispatch(citaDeleted(id));
                    
                    if (body.cita.citaRelacionada) {
                        dispatch(citaDeleted(body.cita.citaRelacionada));
                    }
                } else if (body.cita) {
                    const datos = {
                        text: [body.msg || 'Servicio eliminado correctamente'],
                        timeOut: 3
                    }
                    dispatch(openModalBottom(datos));
                    dispatch(refreshCita(id, body.cita));
                }
            } else {
                const datos = {
                    title: 'Error',
                    text: [body.msg],
                    buttonText: 'Cerrar'
                }
                dispatch(openModal(datos));
            }
        } catch (error) {
            console.log(error);
        }
    }
}

const citaDeleted = (id) => ({
    type: types.citasDelete,
    payload: id
});

export const citaLogout = () => ({
    type: types.citasLogoutCleaning
});

export const updateCita = (cita) => ({
    type: types.citaUpdated,
    payload: cita
});

export const startUpdateCita = (citaData) => {
    return async (dispatch) => {
        try {
            const resp = getCita(citaData._id);
            const body = await resp.json();

            if (body.ok) {
				dispatch(refreshCita(citaData._id, body.cita));                
                return body;
            }
        } catch (error) {
            console.error('Error al actualizar la cita:', error);
        }
    };
};

const normalizarCitaParaStore = (cita, state) => {
    if (!cita) return cita;
    const profesionales = state.profesionales?.profesionales || [];
    const sucursales = state.sucursales?.sucursales || [];
    const profesionalId = cita.profesional?._id ?? cita.profesional;
    const sucursalId = cita.sucursal?._id ?? cita.sucursal;
    const profesionalObj = typeof cita.profesional === 'object' && cita.profesional !== null && (cita.profesional.nombre != null || cita.profesional._id)
        ? cita.profesional
        : (profesionalId && profesionales.find(p => String(p._id || p) === String(profesionalId)));
    const sucursalObj = typeof cita.sucursal === 'object' && cita.sucursal !== null && (cita.sucursal.nombre != null || cita.sucursal._id)
        ? cita.sucursal
        : (sucursalId && sucursales.find(s => String(s._id || s) === String(sucursalId)));
    return {
        ...cita,
        ...(profesionalObj && { profesional: profesionalObj }),
        ...(sucursalObj && { sucursal: sucursalObj })
    };
};

export const startCambiarProfesionalServicio = (citaId, servicioIndex, nuevoProfesionalId) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const { empresa } = state.auth;
            
            const resp = await fetchConToken(
                `citas/${citaId}/servicio/${servicioIndex}/profesional`,
                { nuevoProfesionalId, empresa },
                'PUT'
            );
            
            const body = await resp.json();

            if (body.ok) {
                const citaNormalizada = normalizarCitaParaStore(body.cita, state);
                dispatch(refreshCita(citaId, citaNormalizada));
                
                const datos = {
                    text: ['Profesional cambiado correctamente'],
                    timeOut: 3
                };
                dispatch(openModalBottom(datos));
                
                return { ok: true, cita: citaNormalizada };
            } else {
                const datos = {
                    title: 'Error',
                    text: [body.msg || 'No se pudo cambiar el profesional'],
                    buttonText: 'Cerrar'
                };
                dispatch(openModal(datos));
                return { ok: false, msg: body.msg };
            }
        } catch (error) {
            console.error('Error al cambiar profesional:', error);
            const datos = {
                title: 'Error',
                text: ['Ha ocurrido un error al cambiar el profesional'],
                buttonText: 'Cerrar'
            };
            dispatch(openModal(datos));
            return { ok: false, error };
        }
    };
};